import component from './component.vue';

export default component;
